<template>
    <div class="content-inner">
        <x-panel margin>
            <div slot="title">Teams</div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-input v-model="listFilters.search" placeholder="Search... " clearable style="width: 400px;"
                          class="filter-item mr-2" @keyup.enter.native="handleFilter" @clear="handleFilter"/>
                <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
                    Search
                </el-button>
                <el-button type="success" icon="fa-users-medical" @click="handleCreate">
                    Create Team
                </el-button>
            </div>
        </x-panel>
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="listLoading"
            fit
            ref="filterTable"
            row-key="id"
            border
            default-expand-all>
            <el-table-column
                prop="id"
                label="ID"
                fixed="left"
                width="50">
            </el-table-column>
            <el-table-column
                prop="name"
                label="Team Name">
            </el-table-column>
            <el-table-column
                label="Team Members">
                <template slot-scope="scope">
                    {{ scope.row.users.length }}
                </template>
            </el-table-column>
            <el-table-column
                prop="deleted_at"
                label="Status">
                <template slot-scope="scope">
                    <el-tag v-if="!scope.row.deleted_at" type="success">Active</el-tag>
                    <el-tag v-else type="warning">Inactive</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="Operations"
                width="250">
                <template slot-scope="scope">
                    <el-button v-if="!scope.row.deleted_at" type="success" @click="handleEdit(scope.row, scope.row.id)"
                               round icon="el-icon-edit" size="small">Edit
                    </el-button>
                    <el-button v-else type="success" @click="handleActivate(scope.row, scope.row.id)" round
                               size="small">Activate
                    </el-button>
                    <el-button v-if="!scope.row.deleted_at" type="danger" @click="handleDeactivate(scope.row)" round
                               icon="el-icon-close" size="small">Deactivate
                    </el-button>
                    <el-button v-else type="danger" @click="handlePermenantDelete(scope.row)" round icon="el-icon-close"
                               size="small">Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="collection.total > 0" :total="collection.total" :page.sync="collection.current_page"
                    :limit.sync="collection.per_page" @pagination="getCollection"/>

        {{ /* Create Team */ }}
        <el-dialog :class="`merge-dialog`" title="Create Team" :visible.sync="createTeam.show" :modal="false">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Create Team
            </div>
            <div class="row group-class">
                <div class="col-12 col-lg-6">
                    <label for="team-name">Team Name</label>
                    <el-input class="mb-3" name="team-name" v-model="createTeam.name"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="acl_abn">ABN / ACN</label>
                    <el-input class="mb-3" name="acl_abn" v-model="createTeam.details.acl_abn"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="trading-name">Trading Name</label>
                    <el-input class="mb-3" name="trading-name" v-model="createTeam.details.trading_name"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="registered-business-name">Registered Business Name</label>
                    <el-input class="mb-3" name="registered-business-name"
                              v-model="createTeam.details.registered_business_name"></el-input>
                </div>

                <div class="col-12">
                    <label for="team-members">Team Members</label>
                    <el-select
                        v-model="createTeam.team_members"
                        multiple
                        name="team-members"
                        value-key="id"
                        :class="`w-100`"
                        placeholder="Select">
                        <el-option
                            v-for="member in members"
                            :key="member.id"
                            :label="member.full_name"
                            :value="member">
                        </el-option>
                    </el-select>
                </div>

                <div class="col-12 mt-3">
                    <label for="team-referrers">Team Referrers</label>
                    <multiselect
                        v-model="createTeam.team_referrers"
                        :options="optionsReferrers"
                        :multiple="true"
                        group-values="referrers"
                        group-label="language"
                        :group-select="true"
                        placeholder=""
                        track-by="id"
                        label="name">
                    </multiselect>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="createReset()">Cancel</el-button>
				<el-button type="success" @click="create()" :disabled="createTeam.creating">Create Team</el-button>
			</span>
        </el-dialog>

        {{ /* Edit Team */ }}
        <el-dialog :class="`merge-dialog team-manage`" title="Edit Team" :visible.sync="editTeam.show" :modal="false">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Edit Team
            </div>
            <div class="row group-class">
                <div class="col-12">
                    <h4>TEAM DETAILS</h4>
                </div>
                <div class="col-12 col-lg-6">
                    <label for="team-name">Team Name</label>
                    <el-input class="mb-3" name="team-name" v-model="editTeam.name"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="acl_abn">ABN / ACN</label>
                    <el-input class="mb-3" name="acl_abn" v-model="editTeam.details.acl_abn"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="trading-name">Trading Name</label>
                    <el-input class="mb-3" name="trading-name" v-model="editTeam.details.trading_name"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="registered-business-name">Registered Business Name</label>
                    <el-input class="mb-3" name="registered-business-name"
                              v-model="editTeam.details.registered_business_name"></el-input>
                </div>

                <div class="col-12">
                    <h4>AUSTRALIAN CREDIT LICENSE</h4>
                </div>
                <div class="col-12 col-lg-6">
                    <label for="acl_number">ACR / ACL</label>
                    <el-input class="mb-3" name="acl_number" v-model="editTeam.details.acl_number"></el-input>

                    <label for="acl_address">ACL Address</label>
                    <el-input class="mb-3" name="acl_address" v-model="editTeam.details.acl_address"></el-input>
                </div>
                <div class="col-12 col-lg-6">
                    <label for="acl_email">ACL Email</label>
                    <el-input class="mb-3" name="acl_email" v-model="editTeam.details.acl_email"></el-input>

                    <label for="acl_phone">ACL Phone</label>
                    <el-input class="mb-3" name="acl_phone" v-model="editTeam.details.acl_phone"></el-input>
                </div>

                <div class="col-12">
                    <h4>TEAM BRANDING</h4>
                </div>

                <div class="col-12">
                    <label for="logo">Logo</label>
                    <section class="logo-box">
                        <el-image
                            style="max-width: 100%; max-height: 100px; min-height: 100px;"
                            :class="`override-logo img-fluid`"
                            :src="getEditLogo()"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                        <file-upload class="upload-action" :modal="true"
                                     :title="`Upload Logo`"
                                     :endpoint="`/api/settings/teams/${editTeam.id}/resources/setlogo`"
                                     :hasFiles="hasFiles"
                                     @uploadSuccess="setLogoResponse"
                                     label="Drop logo here to upload <b><em>or</em></b> <span style='text-decoration: underline;'>click to browse</span>"
                                     :icon="true"
                        />
                    </section>
                </div>

                <div class="col-12">
                    <h4>MEMBERS</h4>
                </div>

                <div class="col-12">
                    <label for="team-members">Team Members</label>
                    <el-select
                        v-model="editTeam.team_members"
                        multiple
                        name="team-members"
                        value-key="id"
                        :class="`w-100`"
                        placeholder="Select">
                        <el-option
                            v-for="member in members"
                            :key="member.id"
                            :label="member.full_name"
                            :value="member">
                        </el-option>
                    </el-select>
                </div>

                <div class="col-12 mt-3">
                    <h4>REFERRERS</h4>
                </div>

                <div class="col-12">
                    <label for="team-referrers">Team Referrers</label>
                    <multiselect
                        v-model="editTeam.team_referrers"
                        :options="optionsReferrers"
                        :multiple="true"
                        group-values="referrers"
                        group-label="language"
                        :group-select="true"
                        placeholder=""
                        track-by="id"
                        label="name">
                    </multiselect>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="editReset()">Cancel</el-button>
				<el-button type="success" @click="edit()">Update Team</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@shared/components/pagination'
import Multiselect from "vue-multiselect"

export default {
    name: 'AmbitionTeams',
    components: {
        Pagination,
        Multiselect
    },
    props: {
    },
    data() {
        return {
            collection: {},
            members: [],
            optionsReferrers: [
                {
                    language: 'Select All',
                    referrers: []
                }
            ],
            referrersSelect: [],
            defaults: [],
            defaultLogo: '',
            search: '',
            hasFiles: true,
            listLoading: true,
            listFilters: {
                search: '',
            },
            team: {},
            listLimit: 10,
            createTeam: {
                show: false,
                creating: false,
                name: '',
                details: {
                    trading_name: '',
                    registered_business_name: '',
                    acl_abn: '',
                    acl_number: '',
                    address: '',
                    bank_statement_codes: '',
                    credit_check_blocks: '',
                    hem_benchmark: '',
                    logo: ''
                },
                team_members: [],
                team_referrers: []
            },
            editTeam: {
                show: false,
                id: null,
                name: '',
                logo_url: '',
                details: {
                    trading_name: '',
                    registered_business_name: '',
                    acl_abn: '',
                    acl_number: '',
                    address: '',
                    bank_statement_codes: '',
                    credit_check_blocks: '',
                    hem_benchmark: '',
                    logo: ''
                },
                team_members: [],
                team_referrers: [],
                members_removed: [],
                referrers_removed: []
            },
            selected: {}
        }
    },
    computed: {},
    watch: {},
    mounted() {
        this.loadData()
    },
    updated() {
    },
    activated() {
    },
    methods: {
        loadData() {
            this.$tenant.get(`/api/settings/teams`)
                .then((res) => {
                    this.setData(res, 'collection')
                }).catch(err => {
                    err.output()
                })

            this.$tenant.get(`/api/settings/tenant-defaults`)
                .then((res) => {
                    this.setData(res, 'defaults')
                }).catch(err => {
                    err.output()
                }).finally(() => {
                this.defaultLogo = this.defaults.logo
            })

            this.$tenant.get(`/api/settings/tenant-members`)
                .then((res) => {
                    this.setData(res, 'members')
                }).catch(err => {
                    err.output()
                })

            this.$tenant.get(`/api/settings/tenant-referrers`)
                .then((res) => {
                    this.setData(res, 'referrersSelect')
                }).catch(err => {
                    err.output()
                })
        },
        setData(res, model) {
            this.$set(this.$data, model, res.data.collection)
            this.optionsReferrers.filter(referrer => referrer.referrers = this.referrersSelect)
            this.listLoading = false;
            this.$bar.finish()
        },
        clearFilter() {
            this.$refs.filterTable.clearFilter();
        },
        handleFilter() {
            let collection = this.collection;
            let event = {
                page: 1,
                limit: collection.per_page
            }
            this.getCollection(event);
        },
        handleCreate() {
            this.createTeam.show = true;
            this.loadData()
        },
        create() {
            this.createTeam.creating = true
            this.$tenant.post(`/api/settings/teams/create`, {
                    name: this.createTeam.name,
                    details: {
                        ...this.createTeam.details,
                    },
                    team_members: [...this.createTeam.team_members.map(member => member.id)],
                    team_referrers: [...this.createTeam.team_referrers.map(referrer => referrer.id)]
                })
                .then((res) => {
                    this.handleFilter()
                    this.createReset()
                    this.loadData()
                }).catch(err => {
                    err.output()
                }).finally(() => {
                    this.createTeam.creating = false
                })
        },
        createReset() {
            let createTeam = {
                show: false,
                name: '',
                details: {
                    trading_name: '',
                    registered_business_name: '',
                    acl_abn: '',
                    acl_number: '',
                    address: '',
                    bank_statement_codes: '',
                    credit_check_blocks: '',
                    hem_benchmark: '',
                    logo: ''
                },
                team_members: [],
                team_referrers: []
            }

            this.createTeam = createTeam;
        },
        handleEdit(row, id) {
            this.team = row;
            let overrides = {};
            let defaultOverrides = {};
            Object.values(row.system_overrides).map(override => {
                overrides[override.key] = _.get(override, 'override.value', override.value);
            });
            Object.values(this.defaults.system).map(override => {
                defaultOverrides[override.key] = {id: override.id};
            });

            let editTeam = {
                show: false,
                id: id,
                name: row.name,
                logo_url: '',
                details: {
                    ...overrides
                },
                team_members: row.users,
                team_referrers: row.referrers,
                overrides: {...defaultOverrides}
            }

            this.editTeam = editTeam;
            this.getLogo(id, _.get(overrides, 'logo'))
        },
        edit() {
            let editTeam = this.editTeam;
            let team = this.team;
            let remove = _.differenceWith(team.users.map(user => user.id), editTeam.team_members.map(member => member.id));
            let removeReferrers = _.differenceWith(team.referrers.map(referrer => referrer.id), editTeam.team_referrers.map(teamReferrer => teamReferrer.id));
            let updatedDetails = {};
            editTeam.members_removed = [...remove];
            editTeam.referrers_removed = [...removeReferrers];

            Object.keys(editTeam.details).map(override => {
                updatedDetails[_.get(editTeam.overrides[override], 'id', override)] = editTeam.details[override];
            });

            this.$tenant.post(`/api/settings/teams/${editTeam.id}/update`, {
                    name: editTeam.name,
                    details: {
                        ...updatedDetails,
                    },
                    team_members: editTeam.team_members.map(member => member.id),
                    team_referrers: editTeam.team_referrers.map(referrer => referrer.id),
                    members_removed: editTeam.members_removed,
                    referrers_removed: editTeam.referrers_removed
                })
                .then((res) => {
                    this.editReset();
                    this.team = {};
                    this.handleFilter();
                    this.loadData()
                }).catch(err => {
                    err.output()
                })
        },
        editReset() {
            let editTeam = {
                show: false,
                id: null,
                name: '',
                logo_url: '',
                details: {
                    trading_name: '',
                    registered_business_name: '',
                    acl_abn: '',
                    acl_number: '',
                    address: '',
                    bank_statement_codes: '',
                    credit_check_blocks: '',
                    hem_benchmark: '',
                    logo: ''
                },
                team_members: [],
                team_referrers: [],
                members_removed: [],
                referrers_removed: [],
            }

            this.editTeam = editTeam;
        },
        async getLogo(id, url) {
            if (!url) {
                this.editTeam.logo_url = false;

                this.$nextTick(() => {
                    this.editTeam.show = true;
                })
                return;
            }
            let logo = '';
            await this.$tenant.post(`/api/settings/teams/${id}/resources/getlogo`,
                {logo: url})
                .then((res) => {
                    logo = res.data.logo;
                }).catch(err => {
                    err.output()
                })
            this.editTeam.logo_url = logo
            this.$nextTick(() => {
                this.editTeam.show = true;
            })
        },
        setLogoResponse(res) {
            this.editTeam.details.logo = res.data.logo;
            this.editTeam.logo_url = res.data.url;
        },
        getEditLogo() {
            let logo;
            logo = _.get(this.editTeam, 'logo_url');
            if (logo) {
                return logo;
            }

            return this.defaultLogo;
        },
        handleActivate(row) {
            this.$tenant.get(`/api/settings/teams/${row.id}/activate`)
                .then((res) => {
                    this.handleFilter();
                }).catch(err => {
                    err.output()
                })
        },
        deleteValidator(value) {
            if (value == this.selected.name) {
                return true;
            }
            return 'Name has to match exactly';
        },
        handleDeactivate(row) {
            this.selected = row;
            this.$prompt('Please type the name of the team to deactivate', 'De-activate Team', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                customClass: 'manage-group-delete',
                type: 'error',
                inputValidator: this.deleteValidator,
            }).then(({value}) => {
                this.delete(row.id);
            }).catch(() => {

            });
        },
        delete(id) {
            this.$tenant.get(`/api/settings/teams/${id}/delete`)
                .then((res) => {
                    this.handleFilter();
                    this.selected = {};
                }).catch(err => {
                    err.output()
                })
        },
        handlePermenantDelete(row) {
            this.$confirm('Are you sure to permanently delete this team?')
                .then(() => {
                    this.$tenant.get(`/api/settings/teams/${row.id}/permenant-delete`)
                        .then((res) => {
                            this.handleFilter();
                            this.selected = {};
                        }).catch(err => {
                            err.output()
                        })
                })
                .catch(() => {
                });
        },
        getCollection(event) {
            this.$bar.start()
            this.$tenant.get(`/api/settings/teams?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
                .then(res => {
                    this.$set(this.$data, 'collection', res.data.collection)
                    this.listLoading = false;
                    this.$bar.finish()
                }).catch(err => {
                    err.output()
                })
        }
    }
}
</script>

<style lang="scss">
// @import '@assets/sass/backend/_core-variables.scss';
.logo-box {
    position: relative;
    min-height: 120px;

    .action {
        position: absolute;
        right: 10px;
        bottom: 10px;
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background: #bababa;
        text-align: center;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.team-manage {
    h4 {
        margin-bottom: 1rem !important;
    }
}

.multiselect__content-wrapper {
    position: relative;
}

</style>
